import { render, staticRenderFns } from "./DocRelational.vue?vue&type=template&id=4e677d78&scoped=true"
import script from "./DocRelational.vue?vue&type=script&lang=js"
export * from "./DocRelational.vue?vue&type=script&lang=js"
import style0 from "./DocRelational.vue?vue&type=style&index=0&id=4e677d78&prod&lang=scss"
import style1 from "./DocRelational.vue?vue&type=style&index=1&id=4e677d78&prod&lang=scss&scoped=true"
import style2 from "./DocRelational.vue?vue&type=style&index=2&id=4e677d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e677d78",
  null
  
)

export default component.exports